<template>
  <div class="mb-10">
    <NewsHeader />
    <NewsList class="py-8 lg:py-16" />
  </div>
</template>

<script setup lang="ts">
useHead({
  title: "Circus St. Ottilien • Neuigkeiten",
});
</script>
